import { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Button,
  Row,
  MenuProps,
  Skeleton,
  Table,
  Typography,
} from "antd";

// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
// --------------------- Import Styles ---------------------
import { Container } from "./styles";
// --------------------- Import Components ---------------------
import { Columns } from "./components/Columns";
import ModalUsuario from "./components/ModalUsuario";
// --------------------- Import Hooks ---------------------
import { useApartamentos } from "./hooks/useBuscarAptos";
import type { TableProps } from "antd/es/table";
// import { useGerenciarFiltros } from "./hooks/useGerenciarFiltros";
// --------------------- Import Utéis ---------------------
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { useWarning } from "../../uteis/mensagens/useWarning";
import ModalEditar from "./components/ModalEditar";

export default function ViewGerenciarApto() {
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  // Controle de Paginação
  const [currentPage, setCurrentPage] = useState(1);

  // Definições para mobile
  const isMobile = useMediaQuery("(max-width:600px)");

  // Armazena o valor da origem do apartamento
  const [origemApto, setOrigemApto] = useState<number | null>(null);

  // Armazena o valor do Id do apartamento
  const [apId, setApId] = useState<number | null>(null);

  // Armazena o nome do apartamento
  const [apNome, setApNome] = useState<string | null>(null);

  // Armazena o nome do empreendimento
  const [empNome, setEmpNome] = useState<string | null>(null);

  // Armazena a origem do apartamento
  const [origem, setOrigem] = useState<string | null>(null);

  // Definições para exibir a mensagem de alerta
  const [warning, setWarning] = useState<string | undefined>();
  const { showWarning, contextHolder } = useWarning();
  const [warningDisplayed, setWarningDisplayed] = useState(false);

  // Busca os apartamentos
  const { apartamentos, isLoading } = useApartamentos();

  // Verificação de permissaão
  const { isLoading: isTokenLoading, isValid } = usePermissao("OPE");

  // Inicializando o filtro
  const [filteredInfo, setFilteredInfo] = useState<{
    empreend?: string[] | null;
    nomeAp?: string[] | null;
    origemAp?: string[] | null;
  }>({
    empreend: null,
    nomeAp: null,
    origemAp: null,
  });

  const [semFiltros, setSemFiltros] = useState(true);

  // State de abertura e fechamento do modal (Ver proprietario)
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Funçao para abrir o modal (Ver proprietario)
  const usuarioModal = () => {
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal (Ver proprietario)
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  // State de abertura e fechamento do modal (Editar Apartamento)
  const [isModalEditarOpen, setIsModalEditarOpen] = useState(false);

  // Funçao para abrir o modal (Editar Apartamento)
  const editarModal = () => {
    setIsModalEditarOpen(true);
  };

  // Funçao para fechar o modal (Editar Apartamento)
  const handleEditarFechar = () => {
    setIsModalEditarOpen(false);
  };

  // ------------------------------  ---------------------------

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Ver Cotas
      case "1":
        window.location.href = `/gerenciarCotas/?aptoId=${apId}&&aptoNome=${apNome}&&empreendNome=${empNome}`;
        break;

      // Editar Apartamento
      case "2":
        editarModal();
        break;

      // Ver Proprietário
      case "3":
        if (origemApto === 0) {
          setWarning("Propriedade Multicotas");
        } else {
          usuarioModal();
        }
        break;
    }
  };
  // Traz as informações  OnClick, origem , nome e id do apartamento além do nome do empreendimento, ao clickar na linha especifica
  const columns = Columns(
    onClick,
    setOrigemApto,
    setApId,
    setApNome,
    setEmpNome,
    setOrigem,
    {
      empreend: filteredInfo.empreend,
      nomeAp: filteredInfo.nomeAp,
      origemAp: filteredInfo.origemAp,
    }
  );

  // useEffect para lidar com a mensagem
  useEffect(() => {
    if (warning && !warningDisplayed) {
      // Verifica se a mensagem já foi exibida
      showWarning(warning);
      setWarningDisplayed(true);
    }

    // Limpa o estado de mensagem
    setTimeout(() => {
      setWarningDisplayed(false);
      setWarning(undefined);
    }, 3000);
  }, [showWarning, warningDisplayed, warning]);

  useEffect(() => {
    const filtros = localStorage.getItem("filtrosPropriedades");
    const pagina = localStorage.getItem("pageGerPropriedades");

    if (filtros) {
      const novoFiltro = JSON.parse(filtros);
      setFilteredInfo({
        empreend: novoFiltro.empreendimento
          ? [novoFiltro.empreendimento]
          : null,
        nomeAp: novoFiltro.nome ? [novoFiltro.nome] : null,
        origemAp: novoFiltro.origem ? [novoFiltro.origem] : null,
      });
      setSemFiltros(false);
    }

    if (pagina) {
      setCurrentPage(Number(pagina));
    }
  }, []);

  const onChange: TableProps<any>["onChange"] = (pagination, filters) => {
    setFilteredInfo({
      empreend: filters.empreendimento as string[] | null,
      nomeAp: filters.nome as string[] | null,
      origemAp: filters.origem as string[] | null,
    });

    const hasFilters = Boolean(
      filters.empreendimento || filters.nome || filters.origem
    );
    setSemFiltros(!hasFilters);

    if (pagination.current) {
      localStorage.setItem(
        "pageGerPropriedades",
        pagination.current.toString()
      );
    }

    localStorage.setItem("filtrosPropriedades", JSON.stringify(filters));
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosPropriedades");
    localStorage.removeItem("pageGerPropriedades");

    setFilteredInfo({ empreend: null, nomeAp: null, origemAp: null });
    setSemFiltros(true);
    setCurrentPage(1);
  };

  const handleFilter = () => {
    removerFiltros();
  };

  return (
    <>
      {(isLoading && isTokenLoading) || !isValid ? (
        <Skeleton active />
      ) : (
        <Container>
          <>{contextHolder}</>
          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a href={`/inicio`}>
                 
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />

                <Title
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                    fontSize: isMobile ? "1rem" : "2rem",
                    color: "rgb(0, 54, 68)",
                  }}
                  level={3}
                >
                  Gerenciar Apartamentos
                </Title>
              </Flex>
            </Col>
          </Row>
          <Row>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: "auto",
                width: "90%",
                gap: "20px",
              }}
            >
              <div style={{ display: "flex", gap: "20px" }}>
                {/* <Button
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "auto",
                              }}
                              //onClick={adicionarModal}
                              type="primary"
                            >
                              + Indicação Parceiro
                            </Button> */}

                {semFiltros ? (
                  <Button onClick={handleFilter} type="primary" disabled>
                    <FilterAltIcon />
                  </Button>
                ) : (
                  <Button onClick={handleFilter} type="primary">
                    <FilterAltOffIcon />
                  </Button>
                )}
              </div>
            </div>
            <Col span={isMobile ? 5 : 1}></Col>
            <Col
              span={22}
              style={{
                marginTop: isMobile ? 15 : 20,
                marginBottom: isMobile ? 30 : 50,
              }}
            >
              <Flex
                style={{
                  width: isMobile ? "auto" : "100%",
                  overflow: "auto",
                  marginLeft: 50,
                }}
              >
                <Table
                  columns={columns}
                  dataSource={apartamentos}
                  onChange={onChange}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: isMobile ? "auto" : "100%",
                    maxWidth: isMobile ? "none" : "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage }}
                />
              </Flex>
            </Col>
            <Col span={1}></Col>
          </Row>
          <ModalUsuario
            isModalOpen={isModalOpen}
            handleFechar={handleFechar}
            origemApto={origemApto}
          />
          <ModalEditar
            isModalOpen={isModalEditarOpen}
            handleFechar={handleEditarFechar}
            aptoId={apId}
          />
        </Container>
      )}
      ;
    </>
  );
}
